import { render, staticRenderFns } from "./telegramCon.vue?vue&type=template&id=3dca48fa&scoped=true&"
import script from "./telegramCon.vue?vue&type=script&lang=js&"
export * from "./telegramCon.vue?vue&type=script&lang=js&"
import style0 from "./telegramCon.vue?vue&type=style&index=0&id=3dca48fa&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca48fa",
  null
  
)

export default component.exports